module.exports = __webpack_public_path__ + "assets/media/unlock-character.a8deda41.wav";